
import { isConsulePrintable } from '../utils/lodash';
import _ from 'lodash';
import { format } from "date-fns";

/**
 * 做Log这个类的目的时为了区分打印来源，能够暂停部分打印。一般来说单个函数应该从fileLogger里创建出一个子logger来，这个logger独立控制自己是否需要打印。我在很多地方会预留一行// logger.pause = true;的目的就是为了人类通过ctrl+/的方式快速开启关闭log，这点的使用习惯和ai会有所不同，因为你输出几行文字是很快的，而人类用ctrl+/要比打字要快
 * 
 * 
 * 
 * 
 */
let logIndex = 0;
let colorsIndex = 0;
const colors = [
  '#f1581f',
  '#003366',
  '#990033',
  '#663366',
  '#CCCC99',
  '#CC9999',
  '#003300',
  '#8cc540',
  '#009f5d',
  '#019fa0',
  '#019fde',
  '#ff1244',
  '#ff8345',
];
export class Log {
  static isInApp = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('droid-lego-android----------') > -1;
  static eventWarnAdd = 'warnAdd';
  static eventErrorAdd = 'errorAdd';
  // static dispatcher = new EventDispatcher();
  static warnList = [];
  static errorList = [];
  static logStoreMaxLength = 100;
  static addWarn = (s:string) => {
    Log.addLog(Log.warnList, s, Log.eventWarnAdd);
  };
  static addError = (s:string) => {
    Log.addLog(Log.errorList, s, Log.eventErrorAdd);
  };
  static addLog = (list:string[], s:string, event:any) => {
    if (list.length > Log.logStoreMaxLength) {
      list.shift();
    }
    // s = `${formatDate(new Date(), 'DD HH:MM:SS')}`;
    s = format(new Date(), "dd hh:mm:ss");
    // s = `${new Date().toLocaleString()}`
    list.push(s);
    // Log.dispatcher.dispatchEvent(new DataEvent(event, list));
  };
  static forbidden = [];
  static allowed = [];
  prefixies:string[]
  prefix:string
  isPaused:boolean
  globalIndex:number
  index:number
  parent?:Log|undefined
  isChildrenPaused:boolean
  isForcePrint:boolean
  color:string
  logger:Log
  constructor(paused:boolean, ...prefixies:string[]) {
    this.prefixies = prefixies;
    this.prefix = prefixies.join(' ');
    this.isPaused = !!paused;
    this.globalIndex = logIndex++;
    this.index = 0;
    this.parent = undefined;
    this.isChildrenPaused = false;
    this.isForcePrint = false;
    this.color = colors[colorsIndex++ % colors.length];
    this.logger = this;
  }
  static countMap = new Map<string, number>();
  static createCountedLogger = (paused:boolean, name:string, ...prefixies:string[]) => {
    let v = Log.countMap.get(name) ?? 0;
    v++;
    Log.countMap.set(name, v)
    let prefix = `${name} ${v}`;
    let arr = prefixies.concat(prefix);
    let log = new Log(paused, ...arr);
    log.index = v;
    return log;
  };
  sub = (paused:boolean, name:string) => {
    let log = Log.createCountedLogger(paused, `${name}`, ...this.prefixies);
    log.parent = this;
    return log;
  };
  set forcePrint(p) {
    this.isForcePrint = !!p;
  }
  get forcePrint() {
    return this.isForcePrint;
  }
  set pause(p) {
    this.isPaused = !!p;
  }
  get pause() {
    return this.isPaused;
  }
  set childrenPaused(p) {
    this.isChildrenPaused = !!p;
  }
  get childrenPaused() {
    return this.isChildrenPaused;
  }
  get canPrint() {
    if (this.isForcePrint) return true;
    if (this.isPaused) return false;
    let p = this.parent;
    while (p) {
      if (p.isChildrenPaused) return false;
      p = p.parent;
    }
    return true;
  }
  warn = (...args:unknown[]) => {
    // const arr = this.print.apply(this, args)?? [];
    // Log.addWarn(arr.join(' '));
    const {format, arr} = this.buildParams(...args);
    console.warn(format, ...arr);
  };
  error = (...args:unknown[]) => {
    const isForcePrint = this.isForcePrint;
    this.isForcePrint = true;
    // const arr = this.print.apply(this, args) ??[];
    const {format, arr} = this.buildParams(...args);
    console.error(format, ...arr);
    console.trace('Log error trace')
    this.isForcePrint = isForcePrint;
    Log.addError(arr.join(' '));
  };
  info = (...args:unknown[]) => {
    const {format, arr} = this.buildParams(...args);
    console.info(format, ...arr);
  };
  print = (...args:unknown[]) => {
    if (!this.canPrint) return;
    // let l = this;
    // let retArray:any[] = [];
    // let arr:any[] = [];
    // let format = '';
    // format = this.loopParent(l, arr, (l:Log) => l.globalIndex, format);

    // arr.unshift('@');
    // if (!Log.isInApp) {
    //   format += '%c%s ';
    //   arr.unshift('color:#000000;font-weight: bold;');
    // }

    // format = this.loopParent(l, arr, (l:Log) => l.index, format);

    // if (!Log.isInApp) {
    //   format += '%c%s ';
    //   arr.push('color:#000000;font-weight: bold;');
    // }
    // if (Log.isInApp) {
    //   for (let i = 0; i < args.length; i++) {
    //     if (!isConsulePrintable(args[i] as {
    //       nodeType:number
    //       nodeName:string
    //   })) {
    //       try {
    //         const o = args[i];
    //         let v = '';
    //         if (_.isError(o)) {
    //           v = o.message + '\n' + o.stack;
    //         } else {
    //           v = JSON.stringify(args[i]);
    //           // chrome扩展不允许eval所以这里做一下临时处理
    //           // v = JSON.stringify(jc.decycle(args[i]));
    //         }
    //         args[i] = v;
    //       } catch (e) {
    //         console.log('log print json stringify error', e);
    //         console.log('log print json stringify error stack is', _.isError(e) ? e.stack : '');
    //       }
    //     }
    //   }
    // }
    // arr.push(this.prefix);
    // arr = arr.concat(args);
    const {format, arr} = this.buildParams(...args);
    console.log(format, ...arr);
    const retArray = arr.slice()
    return retArray;
  };
  private buildParams(...args:unknown[]){

    let l = this;
    let retArray:any[] = [];
    let arr:any[] = [];
    let format = '';
    format = this.loopParent(l, arr, (l:Log) => l.globalIndex, format);

    arr.unshift('@');
    if (!Log.isInApp) {
      format += '%c%s ';
      arr.unshift('color:#000000;font-weight: bold;');
    }

    format = this.loopParent(l, arr, (l:Log) => l.index, format);

    if (!Log.isInApp) {
      format += '%c%s ';
      arr.push('color:#000000;font-weight: bold;');
    }
    if (Log.isInApp) {
      for (let i = 0; i < args.length; i++) {
        if (!isConsulePrintable(args[i] as {
          nodeType:number
          nodeName:string
      })) {
          try {
            const o = args[i];
            let v = '';
            if (_.isError(o)) {
              v = o.message + '\n' + o.stack;
            } else {
              v = JSON.stringify(args[i]);
              // chrome扩展不允许eval所以这里做一下临时处理
              // v = JSON.stringify(jc.decycle(args[i]));
            }
            args[i] = v;
          } catch (e) {
            console.log('log print json stringify error', e);
            console.log('log print json stringify error stack is', _.isError(e) ? e.stack : '');
          }
        }
      }
    }
    arr.push(this.prefix);
    arr = arr.concat(args);
    return {format, arr, retArray};
  }
  log = this.print.bind(this);
  loopParent = (l:Log|undefined, arr:any[], fn:(l:Log)=>number, format:string) => {
    while (l) {
      arr.unshift(fn(l));
      if (!Log.isInApp) {
        format += '%c%s ';
        arr.unshift(`color:${l.color};font-weight: bold;`);
      }
      l = l.parent;
    }
    return format;
  };
}

// export function createLogger(clazz:any) {
//   const log = Log.createCountedLogger(false, clazz.name);
//   clazz.prototype._log = log;
//   clazz.prototype._print = log.print;
//   return clazz;
// }




export interface ILogExtraConfigExtraMatch {
  prefix?: string;
  fn?: (from: string, target: any, ...args: any[]) => boolean;
}
export interface ILogExtraConfig {
  printName?: string;
  alias?: string;
  extraMatch?: ILogExtraConfigExtraMatch;
}

export function checkCanPrintLog(conf: ILogExtraConfig, from: string, target: any, ...args: any[]) {
  if (!conf) return true;
  if (!conf.extraMatch) {
    if (conf.alias) return from == conf.alias;
    return true;
  }
  if (conf.extraMatch.prefix && from.indexOf(conf.extraMatch.prefix) == -1) return false;
  if (conf.extraMatch.fn && !conf.extraMatch.fn(from, target, ...args)) return false;
  if (conf.extraMatch.fn) return conf.extraMatch.fn(from, target, ...args);
  if (conf.extraMatch.prefix) return from == conf.extraMatch.prefix;
  return false;
}

const logMap = new WeakMap<any, ILogExtraConfig>();
/**
 * 添加打印目标，这个打印可用于一些公用打印，比如ProxyWatch里要打印特定target的信息。
 * @param target 要打印的target
 * @param conf 打印配置。如果配置为空则打印，如果配置了alias则比较alias与输入的frome相同则打印，如果配置了extraMatch则比较extraMatch，首先检测extrMatch.fn，如果fn存在则调用fn，fn返回true则打印。如果fn不存在则比较prefix，如果prefix存在则比较prefix与输入的from是否相同，如果相同则打印。
 */
export function logAddPrintTarget(target: any, conf: ILogExtraConfig = {}) {
  // console.log(
  //   'logAddPrintTarget target=',
  //   target,
  //   'conf=',
  //   conf,
  //   'objectCount=',
  //   objectCountUtils.getObjectCount(target),
  // );
  logMap.set(target, conf);
}
export function logRemovePrintTarget(target: any) {
  logMap.delete(target);
}

export function logGetPrintTargetConf(target: any) {
  return logMap.get(target);
}
export function checkTargetCanPrintLog(target: any, from: string, ...args: any[]) {
  const conf = logMap.get(target);
  // console.log('checkTargetCanPrintLog logMap.get(target)=', conf, target);
  if (!conf) {
    // console.warn(
    //   '11111 logmap not found target=',
    //   'objectCount=',
    //   objectCountUtils.getObjectCount(target),
    //   'target=',
    //   target,
    // );
    // for (const key in logMap) {
    //   console.warn('logMap key=', key, 'logMap value=', logMap.get(key));
    // }
    return { conf, ok: false };
  }
  const ok = checkCanPrintLog(conf, from, target, ...args);
  return { conf, ok };
}

export function printPassedTargetLog(log: Log, target: any, from: string, ...args: any[]) {
  const conf = logMap.get(target);
  if (!conf) return;
  if (!checkCanPrintLog(conf, from, target, ...args)) return;
  const list: any[] = [];
  if (conf.printName) list.push(conf.printName);
  else {
    list.push(from);
    if (conf.alias) list.push('alias=', conf.alias);
    if (conf.extraMatch?.prefix) list.push('prefix=', conf.extraMatch.prefix);
  }
  list.push(...args);
  log.print(...list);
}
